import Workouts from '../constants/Training/Workouts';

async function getWorkouts(request) {
  console.log('trainingServices.getWorkouts() ', request);
  const { workoutType } = request.payload;
  const workouts = Workouts.ByType.find((element) => element.type === workoutType);

  if (!workouts) {
    throw new Error('Workout type not found');
  }

  return workouts.workouts;
}

async function getWorkout(request) {
  console.log('trainingServices.getWorkout() ', request);
  const { workoutName } = request.payload;
  const workout = Workouts.ByName.find((element) => element.name === workoutName);

  if (!workout) {
    throw new Error('Workout not found');
  }

  return workout;
}

async function getExercises(request) {
  console.log('trainingServices.getExercises() ', request);
  const { workoutName } = request.payload;
  const workout = Workouts.ByName.find((element) => element.name === workoutName);

  if (!workout) {
    throw new Error('Workout not found');
  }

  return workout.exercises;
}

const trainingServices = {
  getWorkouts,
  getWorkout,
  getExercises,
};

export default trainingServices;
